import React from 'react';
import { PublicHeader } from '../components/PublicHeader';
import { TermsContent } from '../components/LegalModal';
import { useForceLightMode } from '../hooks/useForceLightMode';

export const TermsPage: React.FC = () => {
  useForceLightMode();

  return (
    <div className="min-h-screen bg-gradient-to-br from-medical-50 via-white to-primary-50/30">
      <PublicHeader />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-bold text-medical-900 mb-8">Terms of Service</h1>
        <div className="prose prose-sm prose-medical max-w-none">
          <TermsContent />
        </div>
      </div>
    </div>
  );
};
